export default {
    create(data,status=500) {
        return {
            status: status,
            response: {
                status: status,
                data: data
            }
        }
    }
}
